import {Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE, DateAdapter} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import * as moment from 'moment';
import 'moment/locale/pt-br';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {Moment} from 'moment';


const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date-picker-padrao',
  standalone: true,
  imports: [MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule, ReactiveFormsModule],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
  ],
  templateUrl: './date-picker-padrao.component.html',
  styleUrl: './date-picker-padrao.component.css'
})
export class DatePickerPadraoComponent implements OnChanges {

  private readonly dateAdapter = inject<DateAdapter<Moment>>(DateAdapter);

  @Output() envioDataSelecionada = new EventEmitter<any>();

  dataControl = new FormControl<Moment | null>(null);

  @Input() data: Moment | null = null;
  @Input() dataMinima: Moment | null = null;
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() label = 'Data';
  @Input() widthFormField = '160px';
  @Input() carregandoInfo?: boolean = false;


  constructor() {
    moment.locale('pt-br');
    moment.updateLocale('pt-br', {
      longDateFormat: {
        LTS: 'HH:mm:ss',
        LT: 'HH:mm',
        L: 'DD/MM/YYYY',
        l: 'D/M/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY HH:mm',
        LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
      }
    });
    this.dateAdapter.setLocale('pt-BR');

    this.dataControl.valueChanges.subscribe(value => {
      this.envioDataSelecionada.emit(value);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['disabled']) {
      if (this.disabled) {
        this.dataControl.disable();
      } else {
        this.dataControl.enable();
      }
    }
    if (changes['data']) {
      const novaData: Moment | null = changes['data'].currentValue;
      if (novaData && !this.datasIguais(this.dataControl.value, novaData)) {
        this.dataControl.setValue(novaData);
        this.envioDataSelecionada.emit(novaData);
      }
    }
  }

  private datasIguais(data1: Moment | null, data2: Moment | null): boolean {
    return data1?.isSame?.(data2, 'day') || false;
  }

}
